import React, { useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";

import { Link } from "react-router-dom";
import {
  PaymentLinkSideBarContainer,
  ImageCon,
  SideBarContainer,
  SideBarContent1,
  SideBarContent2,
  SideBarContent3,
  SideBarContent4,
  SideBarContent5,
  SideBarContent6,
  MainMenuText,
  LogOutText,
  Span0,
  Span,
  Span7,
  XIcon,
  FipayLogo,
  FipayMobileLogo,
  CloseButton,
} from "./Sidebar.styles";
import { useDispatch } from "react-redux";
import { clearStorage } from "../../../store";

interface CloseButtonProps {
  icon: string;
  onClick: () => void;
}

const PaymentLinkSidebar = ({
  closeButton,
}: {
  closeButton?: CloseButtonProps;
}) => {
  const dispatch = useDispatch();

  const [activeItem, setActiveItem] = useState("");
  const navigate = useNavigate();
  const location = useLocation();
  const currentRoute = location.pathname;

  const NavigateToHomePage = () => {
    setActiveItem("home");
    navigate("/dashboard");
  };
  const NavigateToAccountsPage = () => {
    setActiveItem("Accounts");
    navigate("/dashboard/accounts");
  };
  const NavigateToTransactionPage = () => {
    setActiveItem("transaction");
    navigate("/dashboard/transaction");
  };

  const NavigateToPaymentLinkPage = () => {
    setActiveItem("paymentLink");
    navigate("/dashboard/payment-link");
  };

  const NavigateToInvoicePage = () => {
    setActiveItem("invoice");
    // navigate("/dashboard/invoice");
  };

  const NavigateToReportPage = () => {
    setActiveItem("reports");
    // navigate("/dashboard/reports");
  };

  const NavigateToSettingPage = () => {
    setActiveItem("settings");
    navigate("/dashboard/settings");
  };
  const NavigateToAccountHolderPage = () => {
    setActiveItem("userManagement");
    navigate("/dashboard/user-profile");
  };

  const handleLogout = () => {
    dispatch(clearStorage());
    window.location.href = "/auth/login";
  };
  return (
    <PaymentLinkSideBarContainer>
      <ImageCon>
        <Link to="/">
          <FipayLogo src="/assets/icons/fipay.svg" alt="fipaylogo" />
        </Link>
        <Link to="/">
          <FipayMobileLogo
            src="/assets/icons/fipay-mobile.svg"
            alt="fipaylogo"
          />
        </Link>
      </ImageCon>
      {closeButton && (
        <CloseButton onClick={closeButton.onClick}>
          <XIcon src={closeButton.icon} alt="close-icon" />
        </CloseButton>
      )}

      <MainMenuText>
        <Span0>Main Menu</Span0>
      </MainMenuText>

      <SideBarContainer>
        <SideBarContent1
          onClick={NavigateToHomePage}
          style={{
            paddingBottom: "10px",
            borderLeft: activeItem === "home" ? "3px solid #00A603" : "none",
            background:
              currentRoute === "/dashboard"
                ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
                : undefined,
            width: "100%",
          }}
        >
          <img
            src={
              currentRoute === "/dashboard"
                ? "/assets/svg/Home_Green.svg"
                : "/assets/home.png"
            }
            alt="home"
          />{" "}
          <Span
            style={{
              color: currentRoute === "/dashboard/home" ? "#00A603" : "",
            }}
          >
            Home
          </Span>
        </SideBarContent1>
        <SideBarContent6
          onClick={NavigateToAccountsPage}
          style={{
            paddingBottom: "10px",
            borderLeft:
              activeItem === "userManagement" ? "3px solid #00A603" : "none",
            background:
              currentRoute === "/dashboard/accounts"
                ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
                : undefined,
            width: "100%",
          }}
        >
          <img
            src={
              currentRoute === "/dashboard/accounts"
                ? "/assets/icons/wallet2_green.svg"
                : "/assets/empty-wallet2.png"
            }
          />
          {/* <img src="/assets/setting.png" alt="accounts" />{" "} */}
          <Span
            style={{
              color: currentRoute === "/dashboard/accounts" ? "#00A603" : "",
            }}
          >
            Accounts
          </Span>{" "}
        </SideBarContent6>
      </SideBarContainer>
      <SideBarContent2
        onClick={NavigateToTransactionPage}
        style={{
          paddingBottom: "10px",
          borderLeft:
            activeItem === "transaction" ? "3px solid #00A603" : "none",
          background:
            currentRoute === "/dashboard/transaction"
              ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
              : undefined,
          width: "100%",
        }}
      >
        <img
          src={
            currentRoute === "/dashboard/transaction"
              ? "/assets/svg/TransactionIcon_Green.svg"
              : "/assets/TransactionIcon.png"
          }
          alt="TransactionIcon"
        />{" "}
        <Span
          style={{
            color: currentRoute === "/dashboard/transaction" ? "#00A603" : "",
          }}
        >
          Transaction
        </Span>
      </SideBarContent2>
      <SideBarContent3
        onClick={NavigateToPaymentLinkPage}
        style={{
          paddingBottom: "10px",
          borderLeft:
            activeItem === "paymentLink" ? "3px solid #00A603" : "none",
          background:
            currentRoute === "/dashboard/payment-link"
              ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
              : undefined,
          width: "100%",
        }}
      >
        <img
          src={
            currentRoute === "/dashboard/payment-link"
              ? "/assets/moneys.png"
              : "/assets/svg/money_White.svg"
          }
          alt="money"
        />{" "}
        <Span
          style={{
            color: currentRoute === "/dashboard/payment-link" ? "#00A603" : "",
          }}
        >
          Payment Link
        </Span>
      </SideBarContent3>
      <SideBarContent4
        onClick={NavigateToInvoicePage}
        style={{
          paddingBottom: "10px",
          borderLeft: activeItem === "invoice" ? "3px solid #00A603" : "none",
          background:
            currentRoute === "/dashboard/invoice"
              ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
              : undefined,
          width: "100%",
        }}
      >
        <img src="/assets/empty-wallet2.png" alt="empty-wallet" />{" "}
        <Span
          style={{
            color: currentRoute === "/dashboard/invoice" ? "#00A603" : "",
          }}
        >
          Invoice
        </Span>
      </SideBarContent4>
      <SideBarContent5
        onClick={NavigateToReportPage}
        style={{
          paddingBottom: "10px",
          borderLeft: activeItem === "reports" ? "3px solid #00A603" : "none",
          background:
            currentRoute === "/dashboard/reports"
              ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
              : undefined,
          width: "100%",
        }}
      >
        <img src="/assets/receipt2.png" alt="receipt" />{" "}
        <Span
          style={{
            color: currentRoute === "/dashboard/reports" ? "#00A603" : "",
          }}
        >
          Reports
        </Span>{" "}
      </SideBarContent5>
      <SideBarContent5
        onClick={NavigateToSettingPage}
        style={{
          paddingBottom: "10px",
          borderLeft: activeItem === "settings" ? "3px solid #00A603" : "none",
          background:
            currentRoute === "/dashboard/settings"
              ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
              : undefined,
          width: "100%",
        }}
      >
        <img src="/assets/setting.png" alt="setting" />{" "}
        <Span
          style={{
            color: currentRoute === "/dashboard/settings" ? "#00A603" : "",
          }}
        >
          Settings
        </Span>{" "}
      </SideBarContent5>
      <SideBarContent5
        onClick={NavigateToAccountHolderPage}
        style={{
          paddingBottom: "10px",
          borderLeft: activeItem === "accounts" ? "3px solid #00A603" : "none",
          background:
            currentRoute === "/dashboard/user-profile"
              ? "linear-gradient(90.1deg, rgba(125, 129, 125, 0.15) 0.07%, rgba(196, 196, 196, 0) 65.25%)"
              : undefined,
          width: "100%",
        }}
      >
        <img src="/assets/setting.png" alt="user" />{" "}
        <Span
          style={{
            color: currentRoute === "/dashboard/user-profile" ? "#00A603" : "",
          }}
        >
          User Management
        </Span>{" "}
      </SideBarContent5>
      <LogOutText onClick={handleLogout}>
        <img src="/assets/logout.png" alt="logout" />{" "}
        <Span7 onClick={handleLogout}>Log Out</Span7>
      </LogOutText>
    </PaymentLinkSideBarContainer>
  );
};

export default PaymentLinkSidebar;
